<template>
  <div>
    <b-card title="">
      <custom-g-table
        v-if="displayTable"
        ref="custom-table"
        :displayLoading="tableLoading"
        :fields="fields"
        :items="data"
        :totalRows="totalRows"
        :limit="limit"
        @changePage="onChangePage"
        @onSortChange="onSortChange"
        @onColumnFilter="onFilter"
      />
    </b-card>
  </div>
</template>

<script>
import { BCard } from "bootstrap-vue";
import CustomGTable from "@/views/custom/table/CustomGTable.vue";
import auditlogService from "@/providers/auditlogService";
import AppConstants from "@/appConstants";
import dropdownService from "@/providers/dropdownService";
import { setRouteQuery, buildParamsRouteQuery } from "@/helpers/route-query-helper";
import { onlyLatestRequest } from "@/helpers/latest-request-helper";

export default {
  props: {
    urlQuery: Object
  },
  components: {
    BCard,
    CustomGTable,
    // CustomFilter,
  },
  data() {
    return {
      displayTable: false,
      sortField: {},
      data: [],
      totalRows: 0,
      limit: AppConstants.PAGINATOR_DEFAULT_LIMIT,
      page: 1,
      filter: {},
      tableLoading: true,
      fields: [
        {
          field: "dt_create",
          label: "Criação",
          type: "custom_date",
          sortable: true,
          filterOptions: {
            filterValue: '',
            enabled: true,
            placeholder: "Pesquisar por data",
            trigger: "enter",
          },
        },
        {
          field: "name",
          label: "Nome",
          sortable: false,
          filterOptions: {
            filterValue: '',
            enabled: true,
            placeholder: "Pesquisar por nome",
            filterDropdownItems: [],
          },
        },
        {
          field: "action",
          label: "Ação",
          sortable: false,
          filterOptions: {
            filterValue: '',
            enabled: true,
            placeholder: "Pesquisar por ação",
            filterDropdownItems: [],
          },
        },
        {
          field: "description",
          label: "Descrição",
          sortable: true,
          filterOptions: {
            filterValue: '',
            enabled: true,
            placeholder: "Pesquisar por nome",
            trigger: "enter",
          },
        },
        { field: "data", label: "Dados", sortable: false },
        { field: "user", label: "Usuário", type: "object", sortable: false },
        { field: "client", label: "Cliente", type: "object", sortable: false },
        { field: "ip", label: "IP", sortable: false },
        { field: "userAgent", label: "userAgent", sortable: false },
        { field: "visitorId", label: "visitorId", sortable: false },
      ],
      origins: [],
    };
  },
  mounted() {
    this.$store.dispatch("admin/updatePageTitle", "Auditlog");
    this.loadDataFilter();
  },
  computed: {
    searchParams() {
      const params = buildParamsRouteQuery(this.$route.query);
      params.append("page", this.page);
      params.append("limit", this.limit);

      if (this.sortField.field) {
        params.append(`sort_${this.sortField.field}`, this.sortField.type);
      }

      return params;
    },
  },
  methods: {
    setInitialTableFilters() {
      Object.keys(this.urlQuery).forEach(item => {
        this.fields[this.fields.findIndex(val => val.field==item)].filterOptions.filterValue = this.urlQuery[item];
      });
      this.loadData();
    },
    reportData() {
      const params = this.searchParams;
      params.append("download", true);
      auditlogService
        .report(params)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");

          link.href = url;
          link.setAttribute("download", 'auditlog.xlsx');
          link.setAttribute("id", "link-download");

          document.body.appendChild(link);
          link.click();

          document.getElementById("link-download").remove();
        })
        .catch((err) => console.log(err));
    },
    onChangePage(page) {
      this.page = page;
      this.loadData();
    },
    onFilter(data) {
      // this.filter = data;
      // console.log("OnFilter: ", data);
      setRouteQuery(data, this.$route.query);
      this.loadData();
    },
    loadDataFilter() {
      Promise.all([
        dropdownService.getAuditlogAction(new URLSearchParams()),
        dropdownService.getAuditlogName(new URLSearchParams()),
      ])
        .then((res) => {
          this.fields[
            this.fields.findIndex((item) => item.field == "action")
          ].filterOptions.filterDropdownItems = res[0].map((item) => {
            return { value: item, text: item };
          });
          this.fields[
            this.fields.findIndex((item) => item.field == "name")
          ].filterOptions.filterDropdownItems = res[1].map((item) => {
            return { value: item, text: item };
          });
          this.setInitialTableFilters();
        })
        .catch((err) => console.log(err));
    },
    loadData() {
      this.data = [];
      this.tableLoading = true;
      // this.$refs['custom-table'].rows = [];
      // this.$refs['custom-table'].isLoading = true;
      onlyLatestRequest(this, 'loadData', auditlogService.getAllAuditlogs(this.searchParams))
        .then((res) => {
          this.displayTable = true;
          this.data = res.data;
          this.totalRows = res.totalRows;
          this.tableLoading = false;
        })
        .catch((err) => {
          this.displayTable = true;
          console.log(err);
        });
    },
    onSortChange(params) {
      this.sortField = params;
      this.loadData();
    },
  },
};
</script>

<style>
</style>